import { useMemo } from "react";
import { getMeetingDateStr } from "../../../utils/dateUtils";
import { Exhibitor } from "../../../core/types/Exhibitor.model";
import { useData } from "../../../core/contexts/DataContext";


interface ExhibitorsPreviewProps {
    exhibitor: Exhibitor;
    selectedDate: string;
    handleExhibitorSelect: (exhibitor: Exhibitor) => void;
    selectedExhibitor?: Exhibitor;
}

const ExhibitorsPreview = ({
    exhibitor,
    selectedDate,
    handleExhibitorSelect,
    selectedExhibitor
}: ExhibitorsPreviewProps) => {
    const { logosMap } = useData();

    // Calculate total available slots across all sales persons
    const totalAvailableSlots = useMemo(() => {
        if (!exhibitor?.salesPersons) return 0;

        return exhibitor.salesPersons.reduce((total, salesPerson) => {
            const availableCount =
                salesPerson?.meetings?.filter(
                    (slot) =>
                        slot.status === "Available" &&
                        getMeetingDateStr(slot.startTime) === selectedDate
                ).length || 0;

            return total + availableCount;
        }, 0);
    }, [exhibitor, selectedDate]);

    return (
        <div className="col-md-12 col-lg-6 col-xl-4" key={exhibitor.id}>
            <div
                className={`card exhibitor-card h-100 ${selectedExhibitor?.id === exhibitor.id ? 'selected' : ''
                    }`}
                onClick={() => handleExhibitorSelect(exhibitor)}
            >
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <h5 className="card-title fw-semibold text-dark mb-1">
                                {exhibitor.origName}
                            </h5>
                            <p className="text-muted small mb-1">Booth {exhibitor.boothNo}</p>
                            <p className="text-muted small mb-2">{exhibitor.origName}</p>
                            <p className="text-muted small mb-0">
                                <i className="bi bi-people me-1"></i>
                                {exhibitor.salesPersons.length} sales persons
                            </p>
                        </div>
                        <div className="exhibitor-logo me-3">
                            {logosMap[exhibitor.id] != null && <img src={logosMap[exhibitor.id] ?? ''} alt={exhibitor.origName} />}
                        </div>
                        <div className="text-end">
                            <div className="text-success small fw-medium">
                                {totalAvailableSlots} slots available
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExhibitorsPreview;
